module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter2"
    }
  }, [_c('h1', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "href": "#/004toc#january2"
    }
  }, [_vm._v("January 2")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Finding the time to pursue your dreams can be difficult, especially when a restless spirit continually tries to take possession of you. Just keep your eyes on the prize and a bottle of holy water in your pocket—everything else will take care of itself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Dark days:")]), _vm._v(" Monday, Friday")]), _vm._v(" "), _c('div', {
    staticClass: "image",
    attrs: {
      "id": "image4"
    }
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "image 4",
      "src": "images/StarRule.jpg"
    }
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c07f468c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007chapter2.vue
// module id = 75
// module chunks = 0